import { render, staticRenderFns } from "./act.vue?vue&type=template&id=ad9ba9da"
import script from "./act.vue?vue&type=script&lang=js"
export * from "./act.vue?vue&type=script&lang=js"
import style0 from "./act.vue?vue&type=style&index=0&id=ad9ba9da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports